import { forwardRef } from 'react';
import { TextField } from '@mui/material';

export type InputType = 'number' | 'search' | 'password' | 'text';

export interface TextInputProps {
  name: string;
  placeholder: string;
  value: string | number;
  onChange: (value: string | number) => void;
  onBlur?: () => void;
  type?: InputType;
  required?: boolean;
  disabled?: boolean;
  error?: boolean;
  errorInfo?: string;
  autoFocus?: boolean;
  hideLabel?: boolean;
  endAdornment?: React.ReactNode;
  startAdornment?: React.ReactNode;
  autoComplete?: string;
}

const TextInput = forwardRef<HTMLInputElement, TextInputProps>(
  (
    {
      name,
      placeholder,
      value,
      onChange,
      onBlur,
      errorInfo,
      type,
      required = false,
      disabled = false,
      error = false,
      autoFocus = false,
      hideLabel = false,
      endAdornment,
      startAdornment,
      autoComplete = 'off',
    },
    ref
  ) => {
    return (
      <TextField
        id={name}
        inputRef={ref}
        label={hideLabel ? '' : placeholder}
        placeholder={placeholder}
        variant='outlined'
        onBlur={onBlur}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        type={type}
        required={required}
        disabled={disabled}
        error={error}
        autoFocus={autoFocus}
        autoComplete={autoComplete}
        helperText={error && errorInfo}
        fullWidth
        slotProps={{
          htmlInput: { autoComplete },
          ...(endAdornment || startAdornment
            ? { input: { endAdornment, startAdornment } }
            : {}),
        }}
      />
    );
  }
);

export default TextInput;
